var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow bounce",attrs:{"data-aos-delay":"1200","data-aos":"fade-up"}})}
var staticRenderFns = []

export { render, staticRenderFns }